import { Spin } from 'antd';
import { FC, useMemo } from 'react';
import { SubmissionErrors } from 'store/declarations/ireland/ireland-notification';
import DeclarationErrorCards from '../error-cards/DeclarationErrorCards';
import groupErrorCardsByItem from '../error-cards/groupErrorCardsByItem';
import { CenteredSpin } from '../error-cards/DeclarationErrorCard.styles';
import useErrorCardContext from '../error-cards/useErrorCardContext';
import useGoToErrorField from '../useGoToErrorField';
import getAisErrorCards from './getAisErrorCards';

const AisErrorsList: FC<
    SpecificDeclarationErrorsProps & {
        setSelectedError: any;
    }
> = ({ errors, onClose, setSelectedError }) => {
    const { context, isLoaded } = useErrorCardContext();
    const goToErrorField = useGoToErrorField({ onClose, box44Paths: context?.box44Paths });

    const cards = useMemo(
        () => (context ? getAisErrorCards(errors as SubmissionErrors[] | undefined, context) : []),
        [errors, context]
    );

    // Until the history is in, an item could be named by the wrong number.
    if (!isLoaded)
        return (
            <CenteredSpin>
                <Spin />
            </CenteredSpin>
        );

    return (
        <DeclarationErrorCards
            sections={groupErrorCardsByItem(cards)}
            onGoToField={goToErrorField}
            onShowDetails={setSelectedError}
        />
    );
};

export default AisErrorsList;
